import Vue from 'vue'
import Question from '../views/Question.vue'

Vue.config.productionTip = false

import VueResource from 'vue-resource'
Vue.use(VueResource)

new Vue({
  render: h => h(Question)
}).$mount('#app')
